import ModalCommon from 'components/Input/ModalCommon';
import React from 'react';
import { Spin } from 'antd';
import Button from 'components/Button';

const ConfirmChangePassModal = ({
  isOpen,
  onClose,
  onCancel,
  onOk,
  disableSubmit,
}) => {
  return (
    <ModalCommon
      title="パスワード変更"
      open={isOpen}
      onCancel={onClose}
      width={679}
      footer={
        <div className="flex h-max w-full justify-end gap-4 border-t border-[#E6EBF1] pt-[15px]">
          <Button width={120} height={40} btnType="back" onClick={onCancel}>
            キャンセル
          </Button>
          <Button
            width={120}
            height={40}
            btnType="primary"
            onClick={onOk}
            disabled={disableSubmit}
          >
            <p style={{ letterSpacing: '0' }}>確認</p>
          </Button>
        </div>
      }
    >
      <Spin spinning={false}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            gap: 20,
          }}
        >
          <div
            style={{
              textAlign: 'center',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: 130,
              color: '#000000',
              fontSize: 15,
              fontWeight: 400,
            }}
          >
            パスワードを変更します。
            <br /> よろしいですか？
          </div>
        </div>
      </Spin>
    </ModalCommon>
  );
};

export default ConfirmChangePassModal;
